import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SVG from 'components/widgets/icons/svg';

import { openMenu, openRightPane } from 'modules/page-layout/store/actions';
import SearchPopup from 'components/search/popup';

import { stopPropagation } from 'utils/event-handlers';

import { isMobile } from 'constants';

export default function PageHeader({ className, children, title, actions, ...props }) {
  return (
    <div {...props} className={classNames(className, 'page-header', { 'no-children': !children })}>
      <div className="page-header-title">
        <SVG onClick={stopPropagation(openMenu)} src="svg/menu.svg" className="open-menu-icon" />
        <h1>{title}</h1>
        <SVG onClick={() => openRightPane()} src="svg/triage.svg" className="open-sidebar-icon" />
        { !isMobile && actions }
        { !isMobile && <SearchPopup /> }
      </div>
      {children}
    </div>
  );
}

PageHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.node,
  actions: PropTypes.node
};
